import { ListEmail } from "../../components/blackListEmail/ListEmail.component";
import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
export const BlackListEmailListPage = () => {
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header">
            Blacklist Email Domain <BreadCrumbSign /> List
          </p>
          {/* <ListEmail /> */}
          <div className="black-list-email-card d-flex justify-content-center py-3 mt-3">
            <h5>Feature Coming Soon......!</h5>
          </div>
        </div>
      </div>
    </div>
  );
};
